














































































































import { clone } from '@/jbi-shared/util/group-level-attributes.util';
import BaseButton from '@/jbi-shared/vue-components/BaseButton.vue';
import BaseDivider from '@/jbi-shared/vue-components/BaseDivider.vue';
import BaseNumberStepper from '@/jbi-shared/vue-components/BaseNumberStepper.vue';
import { PackageSelection } from '@/store/modules/jtms/short-course-checkout/short-course-checkout.types';
import { RootState } from '@/store/store';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter, State } from 'vuex-class';

@Component({
  components: {
    BaseButton,
    BaseDivider,
    BaseNumberStepper
  }
})
export default class PackageSelectionModal extends Vue {
  @Prop({ type: String, default: 'Date range not provided.', required: true })
  formattedDateRange!: string;
  @Prop({ type: String, default: 'Course Name not provided.', required: true })
  courseName!: string;
  @Prop({ type: String, default: 'AUD', required: true }) currency!: string;
  @Prop({ type: Number, default: 0, required: true }) seats!: number;
  @Prop({ type: Boolean, default: false })
  shouldDisplayCourseAsPackage!: boolean;

  @Getter('course/isFreeCourse')
  isFreeCourse!: boolean;

  @Getter('course/isGroupRegistrationEnabled')
  groupRegistrationEnabled!: boolean;

  @Action('shortCourseCheckout/updatePackageSelections')
  updatePackageSelections!: (payload: PackageSelection[]) => void;

  @State(
    ({ shortCourseCheckout }: RootState) => shortCourseCheckout.selectedPackages
  )
  selectedPackages!: PackageSelection[];

  // Local state to track quantities
  // Final update to state triggered on "Continue" to prevent multiple state mutations
  localPackages: PackageSelection[] = [];

  get localRemainingSeats() {
    return this.seats - this.totalQuantity;
  }

  get formattedPackages(): PackageSelection[] {
    return this.localPackages;
  }

  get totalQuantity(): number {
    return this.localPackages.reduce((sum, pkg) => sum + pkg.quantity, 0);
  }

  get totalPrice(): number {
    return this.localPackages.reduce((sum, pkg) => {
      return sum + parseFloat(pkg.amount) * pkg.quantity;
    }, 0);
  }

  get tooltipText(): string {
    return '';
  }

  get shouldShowTooptip(): boolean {
    return !this.groupRegistrationEnabled;
  }

  created() {
    this.initializePackages();
  }

  initializePackages() {
    if (this.selectedPackages.length === 0) {
      return;
    }

    this.localPackages = clone(this.selectedPackages);
  }

  updateQuantity(index: number, change: number) {
    const pkg = this.localPackages[index];
    const newQty = pkg.quantity + change;

    if (newQty >= 0) {
      const modifiedPackage: PackageSelection = {
        ...pkg,
        quantity: newQty
      };

      this.localPackages.splice(index, 1, modifiedPackage);
    }
  }

  formatPrice(amount: string, currency: string): string {
    const numAmount = parseFloat(amount);
    if (isNaN(numAmount)) {
      return amount;
    }

    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: currency || 'AUD',
      minimumFractionDigits: 2
    }).format(numAmount);
  }

  isPackageDisabled(pkg: PackageSelection): boolean {
    return (this.localRemainingSeats === 0 && pkg.quantity === 0) || false;
  }

  applyDiscount() {
    // Make API call to future discount APIs here, open modal, etc.
  }

  @Emit('continue')
  handleContinue() {
    this.updatePackageSelections(this.localPackages);
    this.closeModal();
  }

  @Emit('close')
  closeModal() {
    return;
  }
}
